import { useState } from "react";
import useDebounce from "../common/useDebounce";

const useSearch = () => {
  const [searchValue, setSearchValue] = useState<string>("");
  const debouncedValue = useDebounce(searchValue, 500);
  const clearSearchValue = () => searchValue && setSearchValue("");
  const handleSeachStringChange = (e) => setSearchValue(e.target.value);

  return {
    debouncedValue,
    searchValue,
    clearSearchValue,
    handleSeachStringChange,
  } as const;
};

export default useSearch;
